import type { ButtonOwnProps } from '@mui/material/Button';
import type { NamedSet } from 'zustand/middleware';

import type { ZustandStore } from '../store.type';

type DialogState = {
	dialog: {
		alert: {
			message: string;
			actionText: string;
			type: ButtonOwnProps['color'];
			open: boolean;
			showCancel: boolean;
			onAccept?: () => void;
			cancelText?: string;
		};
	};
};

export type DialogActions = {
	setDialog: (alert: DialogState['dialog']['alert']) => void;
	closeDialog: () => void;
	resetDialog: () => void;
};

export type DialogSlice = DialogState & DialogActions;

const getDialogInitialState = () => ({
	alert: {
		message: '',
		type: 'info' as const,
		open: false,
		actionText: 'OK',
		showCancel: false,
		onAccept: () => ({}),
	},
});

const dialogInitialState: DialogState = {
	dialog: getDialogInitialState(),
};

export function dialogSlice(set: NamedSet<ZustandStore>): DialogSlice {
	return {
		...dialogInitialState,
		setDialog(alert: DialogState['dialog']['alert']): void {
			set(
				(state: DialogState) => {
					state.dialog.alert = alert;
					return state;
				},
				false,
				'[setDialog]',
			);
		},
		closeDialog(): void {
			set(
				(state: DialogState) => {
					state.dialog.alert.open = false;
					return state;
				},
				false,
				'[closeDialog]',
			);
		},
		resetDialog(): void {
			set(
				(state: DialogState) => {
					state.dialog = getDialogInitialState();
					return state;
				},
				false,
				'[resetDialog]',
			);
		},
	};
}
